const CELLS = [[0, 0], [1, 0], [0, 1], [0, 2], [1, 2], [2, 2]];

export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 29 29" className={className} aria-hidden="true">
    {CELLS.map(([x, y]) => (
      <rect key={`${x}-${y}`} x={x * 10.5} y={y * 10.5} width="8" height="8" fill="currentColor" />
    ))}
    <rect x="21" y="10.5" width="8" height="8" fill="#FF5500" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-6 w-6 text-bone" />
    <span className="font-display text-xl font-semibold tracking-tight">GridJob</span>
  </span>
);
